import LandingAbstract from '@pp-frontend/shared-packages/classes/landing/LandingAbstract'
import { IdentityDoc } from '@pp-frontend/shared-packages/types/dto/IdentityDoc'
import { Events } from '@pp-frontend/shared-packages/types/enum/Events'
import { AxiosResponse } from 'axios'

export default abstract class SearchLandingAbstract extends LandingAbstract {
  /**
   * Тело запроса
   *
   * @returns {*} body
   */
  abstract requestBody (): any

  /**
   * Эндпоинт для получения начислений
   *
   * @returns {string} endpoint
   */
  abstract endpointUrl (): string

  requestBodyErrorValidation (error: any) {
    const dataError = {
      payerData: this.requestBody(),
      error
    }

    this.dataErrorValidation(dataError)
  }

  dataErrorValidation (dataError) {
    this.$router.replace('/').then(() => {
      this.$eventBus.$emit(Events.DATA_ERROR_FROM_VALIDATION, dataError)
    })
  }

  /**
   * Параметры запроса
   *
   * @returns {*} params
   */
  requestParams<P = any> (): P {
    return window.$nuxt.$ga.getStorage()
  }

  getData (token = ''): Promise<AxiosResponse> {
    // @ts-ignore
    return window.$nuxt.$axios.post<IdentityDoc[], AxiosResponse<IdentityDoc[]>>(this.endpointUrl(token), this.requestBody(), {
      params: this.requestParams(),
      timeout: 45_000
    })
  }
}
